<template>
    <div>
        <div>
            <div class="plugins-tips">
                <el-input v-model="query.noticeSearch" placeholder="Filter" @keyup.enter.native="handleUserSearch" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleUserSearch">搜索</el-button>
                <span style="margin-left: 20px; color: #67C23A; font-size: 15px">查询条件："ID, 昵称"</span> 
            </div>
            <el-table
                :data="user.tableData"
                @row-click="rowNoticeClick"
                :header-cell-style="{'text-align':'center'}"
                v-loading="user.loading"
                stripe
            >
                <el-table-column prop="userId" label="ID" align="center"></el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center"></el-table-column>
                <el-table-column prop="priceFree" label="免费货币" align="center"></el-table-column>
                <el-table-column prop="price" label="付费货币" align="center"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="user.pageIndex"
                    :page-size="user.pageSize"
                    :total="user.pageTotal"
                    @current-change="handleUserPageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { getNormalUser } from '../../../api/gameconsole-mars.js'
export default {
    name: 'MarsUser',
    data: function(){
        return {
            query: {
                noticeSearch: '',  //公告搜索
            },
            //公告
            user: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false
            },
        }
    },
    created() {
        this.initUserData()
    },
    activated() {
        this.initUserData()
    },
    methods: {
        //初始化数据
        initUserData() {
            this.user.loading = true
            //如果搜索框不等于 空, 添加搜索条件
            let noticeId = ''
            if (this.query.noticeSearch != '' && this.query.noticeSearch != undefined) {
                noticeId = this.query.noticeSearch
            }

            //发送请求
            let params = {'id': noticeId, 'pageIndex': this.user.pageIndex, 'pageSize': this.user.pageSize }
            getNormalUser(params).then(res => {
                if(res.data.code == 200) {
                    this.user.tableData = res.data.data.records
                    this.user.pageTotal = res.data.data.total
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })
        },
        
        //row点击  进入编辑页
        rowNoticeClick(row, column) {
            if (column.label != '内容') return
            this.$router.push({
                path: `/Notice/${row.id}`
            })
        },

        //搜索框
        handleUserSearch() {
            this.initUserData()
        },

        //上一页 or 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.initUserData()
        },
    }
}
</script>

<style scoped lang="scss">
    /* 鼠标悬浮 */
    ::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
    //  background-color: #212e3e !important;
        cursor: pointer;
    }

    .handle-input {
        width: 260px;
        display: inline-block;
        margin-right: 10px;
    }
</style>
